<template>
  <div>
    <div class="content resume">
      <!-- title -->
      <div class="title">Resume</div>

      <!-- content -->
      <div class="row">
        <!-- experience -->
        <div class="col col-sm-12">
          <div class="row">
            <div class="col col-sm-6 border-line-v">
              <div class="resume-title border-line-h">
                <div class="icon text-end"><i class="fa fa-briefcase"></i></div>
                <div class="name">Experience</div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: -30px">
            <div class="col col-d-12 col-t-12 border-line-v">
              <div class="resume-items">
                <div class="resume-item border-line-h active">
                  <div class="date">Apr 2022 - Present</div>
                  <div class="name">Sr. FullStack Developer</div>
                  <div class="company">Neversitup Co.,Ltd.</div>
                  <ul class="text-white ps-2 text-start">
                    <li>
                      Developed web application for HR Management ( NestJS +
                      React )
                    </li>
                    <li>Config api routing using API Gateway on AWS service</li>
                    <li>
                      Prepare script Infrastructure as Code for deploy in
                      CloudFormation ( AWS )
                    </li>
                  </ul>
                </div>
                <div class="resume-item border-line-h">
                  <div class="date">Jan 2021 - Mar 2022</div>
                  <div class="name">Lead Software Developer</div>
                  <div class="company">UC Connect Co.,Ltd.</div>
                  <ul class="text-white ps-2 text-start">
                    <li>
                      Manage time and resource for projects.
                    </li>
                    <li>
                      Get Requirement , specification and suggestion for
                      solution to customer.
                    </li>
                    <li>Develop web application for transport system</li>
                    <li>
                      Develop stream api via RMTP for stream and HTTP(s) for
                      live video
                    </li>
                    <li>
                      Develop web application for management trainer and learner
                      for online learning ( NestJS + React )
                    </li>
                    <li>
                      Develop web application for 3rd party authentication (
                      Oauth2 ) for use internal api
                    </li>
                  </ul>
                </div>
                <div class="resume-item">
                  <div class="date">Nov 2019 - Dec 2020</div>
                  <div class="name">Sr. Application Programmer</div>
                  <div class="company">UC Connect Co.,Ltd.</div>
                  <ul class="text-white ps-2 text-start">
                    <li>
                      Develop web application API-Gateway for logging or monitor
                      ( NestJS + VueJS ) and used tools Grafana, ElasticSearch
                      and Kong
                    </li>
                    <li>
                      Develop web application for ordering management and used
                      tech server-side events for notification on chrome (
                      NestJS + VueJS )
                    </li>
                    <li>
                      Develop web application for callcenter ordering to "ORDER
                      SYSTEM" and support up to 100 agents
                    </li>
                    <li>Analytical and Resolve problem ( Solving Skill )</li>
                    <li>
                      Develop web application for management trainer and learner
                      for online learning ( NestJS + React )
                    </li>
                    <li>Planning and scrum for team</li>
                  </ul>
                </div>
                <div class="resume-item">
                  <div class="date">Jul 2018 - Oct 2019</div>
                  <div class="name">Application Developer</div>
                  <div class="company">UC Connect Co.,Ltd.</div>
                  <ul class="text-white ps-2 text-start">
                    <li>
                      Develop web service for creating a welcome video for new
                      customers in first insurance ( JAVA )
                    </li>
                    <li>
                      Develop web application payment gateway for agent able
                      send link to customer purchase insurance premium ( PHP +
                      jQuery )
                    </li>
                    <li>
                      Develop web application for support Helpdesk via API Line
                      ( PHP + jQuery )
                    </li>
                    <li>Install PBX for CallCenter</li>
                    <li>Integrate application to PBX ( avaya , asterisk )</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- education -->
        <div class="col col-sm-12">
          <div class="row">
            <div class="col col-sm-6 border-line-v">
              <div class="resume-title border-line-h">
                <div class="icon"><i class="fa fa-university"></i></div>
                <div class="name">Education</div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: -30px">
            <div class="col col-d-12 col-t-12 border-line-v">
              <div class="resume-items">
                <div class="resume-item border-line-h">
                  <div class="date">Jul 2013 - Apr 2017</div>
                  <div class="name">Kasetsart University</div>
                  <div class="company">Sriracha Campus</div>
                  <p>
                    B.Eng Computer Engineering
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "experience"
};
</script>

<style scoped>
ul {
  list-style: circle;
}
</style>
